import { Box, Button, Paper, Typography } from "@mui/material"
import { CustomTable } from "../../table"
import { ChildrenPayload } from "../formatTableData/types"
import { useSelectDataToAssignStyles } from "./styles"
import { LoadingButton } from "@mui/lab"

const SelectDataToAssign = ({ column, row, selectCombination, confirmMassiveLoad, cancelBulkLoad, loading, checks, rowsWithError, text }: ChildrenPayload) => {
    const styles = useSelectDataToAssignStyles()
    return (
        <Box sx={styles.container}>
            <Box sx={styles.containerFlex} className="w-full flex-start">
                <Typography sx={styles.title}>{text.title}</Typography>

                <Typography sx={styles.description}><i>{text.description}</i></Typography>
            </Box>

            <Paper elevation={3} sx={styles.containerFlex} className="w-full padding-5">
                <Box sx={styles.containerFlex}  className="gap-10">
                    <Box sx={styles.containerFlex} className="gap-5">
                        <Typography className="success-store"><b className="bold">{text.success.amount}</b></Typography>
                        <Typography className="success-store">{text.success.description}</Typography>
                    </Box>
                    
                    <div className="separator-r"/>

                    <Box sx={styles.containerFlex} className="gap-5">
                        <Typography className="error-store"><b className="bold">{text.error.amount}</b></Typography>
                        <Typography className="error-store">{text.error.description}</Typography>
                    </Box>
                </Box>

                <Box sx={styles.containerFlex} className="gap-10">
                    <Typography sx={styles.text}><b>{text.buttons.description}</b></Typography>

                    <Button onClick={cancelBulkLoad} className="btn-black" variant="contained">CANCELAR</Button>

                    <LoadingButton loading={loading} onClick={() => { if (checks?.length) { confirmMassiveLoad() } }} disabled={!checks?.length} variant="primary_c">CONFIRMAR</LoadingButton>
                </Box>
            </Paper>

            <CustomTable
                column={column}
                row={row}
                tableChecks
                defaultChecks={checks}

                rowsWithError={{
                    id: rowsWithError,
                    style: styles.warningBg
                }}
                disabledChecks={rowsWithError}
                onClick={selectCombination}
                dontRefresh
                selected={-1}
                handleStopPropagation
            />
        </Box>
    )
}

export { SelectDataToAssign }